import React from 'react';
import { BookprocessStep } from './BookprocessStep';

interface Link {
    href: URL;
    method?: 'GET' | 'POST' | 'PUT';
}

interface Bookprocess {
    id: number;
    name: string;
    _links: {
        self: Link;
        start: Link;
    };
}

interface Bookprocesses {
    _embedded: {
        bookprocess: [Bookprocess];
    };
    _links: {
        self: Link;
    };
}

interface BookprocessSelectState {
    selected: Bookprocess;
    bookprocesses: Bookprocesses;
}

export class BookprocessSelect extends React.Component<{}, BookprocessSelectState> {
    constructor(props: {}) {
        super(props);
        this.state = { bookprocesses: null, selected: null };
        fetch('/api2/bookprocesses/book')
            .then(resp => resp.json())
            .then(bps => this.setState({ bookprocesses: bps }));
    }

    render() {
        if (!this.state.bookprocesses) {
            return '';
        }
        let buttons = this.state.bookprocesses._embedded.bookprocess.map(bp => {
            return (
                <li>
                    <a href={`?id=${bp.id}`}>{bp.name}</a>
                </li>
            );
        });
        let list = <ol id="flows"> {buttons} </ol>;
        if (!this.state.selected) {
            return list;
        }
        let process = (
            <BookprocessStep
                selfURL={this.state.selected._links.self.href}
                key={this.state.selected.id}
            />
        );
        return [list, process];
    }
}
